import { categories } from '@/mocks/categories';

const trendingImages = [
  "https://readdy.ai/api/search-image?query=Dynamic%20editorial%20product%20photography%20of%20premium%20limited%20edition%20sneakers%20suspended%20in%20midair%20with%20colorful%20powder%20explosion%20on%20a%20soft%20warm%20beige%20background%20dramatic%20yet%20playful%20lighting%20modern%20streetwear%20energy%20bold%20creative%20composition%20European%20lifestyle%20aesthetic&width=600&height=800&seq=trend-shoes-v2&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20mixed%20fashion%20accessories%20including%20sunglasses%20a%20silk%20scarf%20and%20minimalist%20jewelry%20arranged%20artfully%20on%20a%20warm%20terracotta%20marble%20surface%20with%20soft%20afternoon%20sunlight%20casting%20gentle%20shadows%20refined%20modern%20European%20luxury%20aesthetic&width=500&height=600&seq=trend-accessories-v2&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Stylish%20product%20shot%20of%20a%20structured%20premium%20designer%20handbag%20with%20gold%20hardware%20on%20a%20soft%20warm%20greige%20pedestal%20with%20dramatic%20yet%20gentle%20side%20lighting%20casting%20angular%20shadows%20modern%20European%20boutique%20photography%20refined%20elegance%20exclusive%20feel&width=500&height=600&seq=trend-bags-v2&orientation=squarish",
];

const trendingItems = [
  { cat: categories[0], trendLabel: 'Bestseller', imageIdx: 0 },
  { cat: categories[9], trendLabel: 'Beliebt', imageIdx: 1 },
  { cat: categories[10], trendLabel: 'Neu', imageIdx: 2 },
];

export default function TrendingProducts() {
  return (
    <section data-product-shop className="py-14 md:py-20 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 mb-3 text-xs font-medium tracking-wider uppercase rounded-full bg-accent-100 text-accent-700">
            Neu & Beliebt
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-900 leading-tight">
            Neue Produkte im{' '}
            <span className="text-primary-600">Oopbuy Spreadsheet</span>
          </h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-lg mx-auto">
            Entdecken Sie die aktuellsten Trends und beliebtesten Artikel im Oopbuy Spreadsheet — täglich aktualisiert.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {trendingItems.map((item, idx) => (
            <a
              key={item.cat.name}
              href={item.cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              style={{ minHeight: idx === 0 ? '420px' : '320px' }}
            >
              <div className="absolute inset-0 z-0">
                <img
                  src={trendingImages[item.imageIdx]}
                  alt={`Oopbuy Spreadsheet ${item.cat.nameDe}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent z-[1]"></div>
              <div className="absolute top-3 left-3 z-10">
                <span className={`inline-block px-3 py-1 text-xs font-medium rounded-full ${
                  item.trendLabel === 'Bestseller'
                    ? 'bg-accent-500 text-background-50'
                    : item.trendLabel === 'Neu'
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-secondary-500 text-background-50'
                }`}>
                  {item.trendLabel}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 z-10 p-5">
                <h3 className="text-lg md:text-xl font-semibold text-white">{item.cat.nameDe}</h3>
                <p className="text-sm text-white/70 mt-1">{item.cat.descDe}</p>
                <span className="inline-flex items-center gap-1 mt-3 text-sm font-medium text-primary-300">
                  Jetzt entdecken
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}